import React from 'react';
import { useNavigate } from 'react-router-dom';

const C = {
  dark: '#0a1628',
  white: '#ffffff',
  gray: '#8899aa',
  accent: '#0071BA',
  border: 'rgba(255,255,255,0.08)',
};

const s = {
  page: { minHeight: '100vh', backgroundColor: C.dark, color: C.white, fontFamily: 'Roboto, sans-serif', padding: '40px 20px' },
  container: { maxWidth: '760px', margin: '0 auto' },
  back: { background: 'none', border: 'none', color: C.gray, cursor: 'pointer', fontSize: '14px', marginBottom: '32px', padding: 0 },
  logo: { fontSize: '22px', fontWeight: 800, color: C.white, marginBottom: '8px', letterSpacing: '2px' },
  title: { fontSize: '28px', fontWeight: 700, marginBottom: '8px' },
  updated: { fontSize: '13px', color: C.gray, marginBottom: '40px' },
  section: { marginBottom: '36px' },
  h2: { fontSize: '17px', fontWeight: 700, color: C.white, marginBottom: '12px', paddingBottom: '8px', borderBottom: `1px solid ${C.border}` },
  p: { fontSize: '15px', color: '#ccd6e0', lineHeight: '1.75', marginBottom: '12px' },
  ul: { paddingLeft: '20px', margin: '8px 0 12px' },
  li: { fontSize: '15px', color: '#ccd6e0', lineHeight: '1.75', marginBottom: '4px' },
  highlight: { color: C.white, fontWeight: 600 },
  link: { color: C.accent, textDecoration: 'none' },
  divider: { borderColor: C.border, margin: '40px 0' },
  contact: { backgroundColor: 'rgba(0,113,186,0.1)', border: '1px solid rgba(0,113,186,0.3)', borderRadius: '12px', padding: '20px 24px' },
};

export default function TerminiUso() {
  const navigate = useNavigate();

  return (
    <div style={s.page}>
      <div style={s.container}>
        <button style={s.back} onClick={() => navigate(-1)}>← Torna indietro</button>

        <div style={s.logo}>OCTA</div>
        <h1 style={s.title}>Termini di Utilizzo</h1>
        <p style={s.updated}>Ultimo aggiornamento: 5 maggio 2026</p>

        <div style={s.section}>
          <h2 style={s.h2}>1. Accettazione dei termini</h2>
          <p style={s.p}>
            Utilizzando OCTA (Online Complete Travel Agency) accetti i presenti Termini di Utilizzo. Se non li accetti, ti invitiamo a non utilizzare la piattaforma.
          </p>
        </div>

        <div style={s.section}>
          <h2 style={s.h2}>2. Descrizione del servizio</h2>
          <p style={s.p}>
            OCTA è una piattaforma web per la pianificazione e condivisione di esperienze di viaggio. Gli utenti possono creare, pubblicare e consultare itinerari di viaggio creati dalla community.
          </p>
        </div>

        <div style={s.section}>
          <h2 style={s.h2}>3. Account utente</h2>
          <p style={s.p}>Per accedere alle funzionalità di OCTA è necessario creare un account. L'utente è responsabile di:</p>
          <ul style={s.ul}>
            <li style={s.li}>Mantenere riservate le credenziali di accesso</li>
            <li style={s.li}>Tutte le attività svolte tramite il proprio account</li>
            <li style={s.li}>Fornire informazioni accurate durante la registrazione</li>
          </ul>
        </div>

        <div style={s.section}>
          <h2 style={s.h2}>4. Contenuti pubblicati</h2>
          <p style={s.p}>
            Pubblicando esperienze di viaggio su OCTA, l'utente dichiara di essere l'autore del contenuto e concede a OCTA una licenza non esclusiva per visualizzarlo sulla piattaforma.
          </p>
          <p style={s.p}>È vietato pubblicare contenuti:</p>
          <ul style={s.ul}>
            <li style={s.li}>Falsi, fuorvianti o fraudolenti</li>
            <li style={s.li}>Offensivi, discriminatori o illegali</li>
            <li style={s.li}>Che violino diritti di terzi (copyright, privacy)</li>
          </ul>
        </div>

        <div style={s.section}>
          <h2 style={s.h2}>5. Limitazione di responsabilità</h2>
          <p style={s.p}>
            OCTA è una piattaforma di condivisione di contenuti generati dagli utenti. Non garantiamo l'accuratezza, la completezza o l'aggiornamento delle esperienze pubblicate. L'utente utilizza tali informazioni a proprio rischio.
          </p>
          <p style={s.p}>
            OCTA non è responsabile per eventuali danni diretti o indiretti derivanti dall'uso della piattaforma o dalle informazioni in essa contenute.
          </p>
        </div>

        <div style={s.section}>
          <h2 style={s.h2}>6. Sospensione e cancellazione account</h2>
          <p style={s.p}>
            Ci riserviamo il diritto di sospendere o cancellare account che violino i presenti termini, senza preavviso. L'utente può cancellare il proprio account in qualsiasi momento scrivendo a{' '}
            <a href="mailto:pasquettofederico@hotmail.it" style={s.link}>pasquettofederico@hotmail.it</a>.
          </p>
        </div>

        <div style={s.section}>
          <h2 style={s.h2}>7. Modifiche ai termini</h2>
          <p style={s.p}>
            Ci riserviamo il diritto di modificare i presenti Termini in qualsiasi momento. Le modifiche saranno pubblicate su questa pagina con la data di aggiornamento. L'uso continuato della piattaforma costituisce accettazione dei nuovi termini.
          </p>
        </div>

        <div style={s.section}>
          <h2 style={s.h2}>8. Legge applicabile</h2>
          <p style={s.p}>
            I presenti Termini sono regolati dalla legge italiana. Per qualsiasi controversia è competente il Foro di Venezia.
          </p>
        </div>

        <hr style={s.divider} />

        <div style={s.contact}>
          <p style={{ ...s.p, marginBottom: 4, fontWeight: 600, color: C.white }}>Contatti</p>
          <p style={{ ...s.p, marginBottom: 0 }}>
            Per qualsiasi domanda scrivi a{' '}
            <a href="mailto:pasquettofederico@hotmail.it" style={s.link}>pasquettofederico@hotmail.it</a>
          </p>
        </div>
      </div>
    </div>
  );
}
